import { PropsWithChildren, ReactElement } from "react";
import { FontIconName } from "../Icon/Icon";
import { IconButton } from "../IconButton/IconButton";
import styles from "./SliderWithToggle.module.less";

export const SliderWithToggle = (props: PropsWithChildren<{}>): ReactElement => {
	const {
		children
	} = props;

	return (
		<div className={styles.root}>
			{ children}
		</div>
	);
};
SliderWithToggle.displayName = "SliderWithToggle";

export const SliderWithToggleSlider = (props: PropsWithChildren<{}>): ReactElement => {
	const {
		children
	} = props;

	return (
		<div className={styles.slider}>
			{ children}
		</div>
	);
};
SliderWithToggleSlider.displayName = "SliderWithToggleSlider";

export type SliderWithToggleToggleProps = {
	icon: FontIconName;
	onClick(): void;
};

export const SliderWithToggleToggle = (props: SliderWithToggleToggleProps): ReactElement => {
	const {
		icon,
		onClick
	} = props;

	return (
		<div className={styles.toggle}>
			<IconButton
				icon={icon}
				kind="secondary"
				onClick={onClick}
				trackingId="slider-with-toggle"
				shape="round"
			/>
		</div>
	);
};
SliderWithToggleToggle.displayName = "SliderWithToggleToggle";

SliderWithToggle.Slider = SliderWithToggleSlider;
SliderWithToggle.Toggle = SliderWithToggleToggle;

